export function sanitizeDirectusObject<T>(objectToSanitize: T | number | null | undefined): T | null {
    return typeof objectToSanitize === "object" ? objectToSanitize : null;
}

export function sanitizeDirectusRelationObject<T, K extends keyof T>(
    objectToSanitize: T | number | null | undefined,
    property: K
): T[K] | null {
    return typeof objectToSanitize === "object" ? (objectToSanitize?.[property] ?? null) : null;
}

export function sanitizeDirectusArray<T>(arrayToSanitize: (T | number)[] | null | undefined): T[] {
    return arrayToSanitize?.filter((item): item is T => typeof item === "object" && item !== null) ?? [];
}

export function sanitizeDirectusRelationArray<T, K extends keyof T>(
    arrayToSanitize: (T | number)[] | null | undefined,
    property: K
): T[K][] {
    return (
        arrayToSanitize
            ?.filter((item): item is T => typeof item === "object" && item !== null)
            .map((item) => item[property]) ?? []
    );
}
